module.exports = __webpack_public_path__ + "assets/img/s2_tab1_active.4474e6b9.png";